import * as Sentry from '@sentry/react'

const logException = (e: Error) => {
  Sentry.captureException(e)
}
export default logException
